<template>
  <div>
    <c-row>
      <c-col xs="12" md="6">
        <c-card v-if="true">
          <c-card-header>
            Radio switches
            <c-badge :color="radio" class="mr-auto">{{ radio }}</c-badge>
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/switch"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </c-card-header>
          <c-card-body>
            <c-switch
              v-for="(color, key) in colors"
              :key="'radio' + key"
              class="mx-1"
              :color="color"
              variant="3d"
              v-bind="labelIcon"
              type="radio"
              name="radio"
              :checked="key === 2"
              :value="color"
              @update:checked="val => (val ? (radio = color) : null)"
            />
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch default
            <c-badge color="primary">{{ checker }}</c-badge>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" name="switch1" :checked.sync="checker" />
            <c-switch
              v-for="(color, key) in ['secondary', 'success', 'warning', 'info', 'danger', 'light', 'dark']"
              :key="key"
              class="mx-1"
              :color="color"
              checked
            />
            <c-switch class="mx-1" color="primary" disabled />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch pills
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked shape="pill" />
            <c-switch class="mx-1" color="secondary" checked shape="pill" />
            <c-switch class="mx-1" color="success" checked shape="pill" />
            <c-switch class="mx-1" color="warning" checked shape="pill" />
            <c-switch class="mx-1" color="info" checked shape="pill" />
            <c-switch class="mx-1" color="danger" checked shape="pill" />
            <c-switch class="mx-1" color="light" checked shape="pill" />
            <c-switch class="mx-1" color="dark" checked shape="pill" />
            <c-switch class="mx-1" color="primary" disabled shape="pill" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            3d Switch
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="3d" />
            <c-switch class="mx-1" color="secondary" checked variant="3d" />
            <c-switch class="mx-1" color="success" checked variant="3d" />
            <c-switch class="mx-1" color="warning" checked variant="3d" />
            <c-switch class="mx-1" color="info" checked variant="3d" />
            <c-switch class="mx-1" color="danger" checked variant="3d" />
            <c-switch class="mx-1" color="light" checked variant="3d" />
            <c-switch class="mx-1" color="dark" checked variant="3d" />
            <c-switch class="mx-1" color="primary" disabled variant="3d" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            3d Switch
            <small><code>disabled</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="3d" disabled />
            <c-switch class="mx-1" color="secondary" checked variant="3d" disabled />
            <c-switch class="mx-1" color="success" checked variant="3d" disabled />
            <c-switch class="mx-1" color="warning" checked variant="3d" disabled />
            <c-switch class="mx-1" color="info" checked variant="3d" disabled />
            <c-switch class="mx-1" color="danger" checked variant="3d" disabled />
            <c-switch class="mx-1" color="light" checked variant="3d" disabled />
            <c-switch class="mx-1" color="dark" checked variant="3d" disabled />
            <c-switch class="mx-1" color="primary" disabled variant="3d" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            3d Switch
            <small><code>label</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" variant="3d" shape="square" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="secondary" checked variant="3d" v-bind="labelIcon" />
            <c-switch class="mx-1" color="success" checked variant="3d" v-bind="labelIcon" />
            <c-switch class="mx-1" color="warning" checked variant="3d" v-bind="labelIcon" />
            <c-switch class="mx-1" color="info" checked variant="3d" v-bind="labelIcon" />
            <c-switch class="mx-1" color="danger" checked variant="3d" v-bind="labelIcon" />
            <c-switch class="mx-1" color="light" checked variant="3d" v-bind="labelIcon" />
            <c-switch class="mx-1" color="dark" checked variant="3d" v-bind="labelIcon" />
            <c-switch class="mx-1" color="primary" disabled variant="3d" v-bind="labelIcon" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>variant="outline"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="outline" />
            <c-switch class="mx-1" color="secondary" checked variant="outline" />
            <c-switch class="mx-1" color="success" checked variant="outline" />
            <c-switch class="mx-1" color="warning" checked variant="outline" />
            <c-switch class="mx-1" color="info" checked variant="outline" />
            <c-switch class="mx-1" color="danger" checked variant="outline" />
            <c-switch class="mx-1" color="light" checked variant="outline" />
            <c-switch class="mx-1" color="dark" checked variant="outline" />
            <c-switch class="mx-1" color="primary" variant="outline" disabled />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>variant="outline" shape="pill"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="secondary" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="success" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="warning" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="info" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="danger" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="light" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="dark" checked variant="outline" shape="pill" />
            <c-switch class="mx-1" color="primary" variant="outline" shape="pill" disabled />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>variant="opposite"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="opposite" />
            <c-switch class="mx-1" color="secondary" checked variant="opposite" />
            <c-switch class="mx-1" color="success" checked variant="opposite" />
            <c-switch class="mx-1" color="warning" checked variant="opposite" />
            <c-switch class="mx-1" color="info" checked variant="opposite" />
            <c-switch class="mx-1" color="danger" checked variant="opposite" />
            <c-switch class="mx-1" color="light" checked variant="opposite" />
            <c-switch class="mx-1" color="dark" checked variant="opposite" />
            <c-switch class="mx-1" color="primary" variant="opposite" disabled />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>variant="opposite" shape="pill"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="secondary" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="success" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="warning" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="info" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="danger" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="light" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="dark" checked variant="opposite" shape="pill" />
            <c-switch class="mx-1" color="primary" variant="opposite" shape="pill" disabled />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>label</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="secondary" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="success" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="warning" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="info" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="danger" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="light" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="dark" checked v-bind="labelIcon" />
            <c-switch class="mx-1" color="primary" disabled v-bind="labelIcon" />
          </c-card-body>
        </c-card>
        shape
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>label shape="pill"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="secondary" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="success" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="warning" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="info" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="danger" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="light" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="dark" checked shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="primary" shape="pill" disabled v-bind="labelIcon" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>label variant="outline"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="secondary" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="success" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="warning" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="info" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="danger" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="light" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="dark" checked variant="outline" v-bind="labelIcon" />
            <c-switch class="mx-1" color="primary" variant="outline" disabled v-bind="labelIcon" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>label variant="outline"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="secondary" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="success" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="warning" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="info" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="danger" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="light" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="dark" checked variant="outline" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="primary" variant="outline" shape="pill" disabled v-bind="labelIcon" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>label variant="opposite"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="secondary" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="success" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="warning" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="info" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="danger" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="light" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="dark" checked variant="opposite" v-bind="labelIcon" />
            <c-switch class="mx-1" color="primary" variant="opposite" disabled v-bind="labelIcon" />
          </c-card-body>
        </c-card>
      </c-col>
      <c-col xs="12" md="6">
        <c-card>
          <c-card-header>
            Switch
            <small><code>label variant="opposite"</code></small>
          </c-card-header>
          <c-card-body>
            <c-switch class="mx-1" color="primary" checked variant="opposite" shape="pill" v-bind="labelTxt" />
            <c-switch class="mx-1" color="secondary" checked variant="opposite" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="success" checked variant="opposite" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="warning" checked variant="opposite" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="info" checked variant="opposite" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="danger" checked variant="opposite" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="light" checked variant="opposite" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="dark" checked variant="opposite" shape="pill" v-bind="labelIcon" />
            <c-switch class="mx-1" color="primary" variant="opposite" shape="pill" disabled v-bind="labelIcon" />
          </c-card-body>
        </c-card>
      </c-col>

      <c-col md="12">
        <c-card>
          <c-card-header>
            Sizes
          </c-card-header>
          <c-card-body class="p-0">
            <c-data-table hover striped class="table-align-middle mb-0" :items="items" :fields="fields" no-sorting>
              <template #example="{item}">
                <td>
                  <c-switch
                    :variant="item.example.variant"
                    :color="item.example.color"
                    :size="item.example.size"
                    :checked="item.example.checked"
                  />
                </td>
              </template>
              <template #size_prop="{item}">
                <td>
                  <span v-html="item.size_prop" />
                </td>
              </template>
            </c-data-table>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'Switches',
  data() {
    return {
      colors: ['primary', 'secondary', 'warning', 'success', 'info', 'danger', 'light', 'dark'],
      fields: [{ key: 'size' }, { key: 'example' }, { key: 'size_prop', label: 'Size prop' }],
      items: [
        {
          size: 'Large',
          example: {
            variant: '3d', color: 'primary', size: 'lg', checked: true,
          },
          size_prop: 'Add following prop <code>size="lg"</code>',
        },
        {
          size: 'Normal',
          example: {
            variant: '3d', color: 'primary', size: '', checked: true,
          },
          size_prop: '-',
        },
        {
          size: 'Small',
          example: {
            variant: '3d', color: 'primary', size: 'sm', checked: true,
          },
          size_prop: 'Add following prop <code>size="sm"</code>',
        },
      ],
      checker: true,
      radio: 'warning',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715',
      },
      labelTxt: {
        labelOn: 'yes',
        labelOff: 'no',
      },
    };
  },
};
</script>
